module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thank you to readers who offered valuable feedback and encouragement along the way: Rachelle Ackerman, Steve Adams, Jan Brown, Lonnie Fairchild, Elizabeth Garfield, Allen Lang, Diana Maher, Danny Miller, Sorrel North, Douglas Skopp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to writing group colleagues for steadfast support: Elizabeth Garfield and Douglas Skopp (again), Susan Carr, Imelda Daranciang, Susie Irwin, Lorna Lee, Cynthia Newgarden, Laura Palkovic, Ann Tracy, Vera Vivante.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to Tom Moran and the Institute for Ethics in Public Life at SUNY Plattsburgh for a room of my own and a place at the table, and to Mike Morgan for guidance on voicing techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to all whose stories, opinions, and insights have guided and inspired me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to Sarah Jacobi and Break Away Books for believing in this project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to Doug Selwyn for more reasons than I have room to list.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a5dd0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Acknowledgement.vue
// module id = 84
// module chunks = 0